import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ErganiDetails  {
    _originalTypeClassName = "zERP.BO.ErganiDetails";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ErganiDetails.translate = translateService;
}
this.Id = null;
this.PaymentTime = null;
this.DigitalJobTimeOrg = false;
this.ObligatoryKnowleadge = false;
this.WorkPlace = null;
this.WorkPlaceComments = null;
this.UnpredictedWorkScedule = false;
this.DaysAndHours = null;
this.MinimumTimeNotice = null;
this.MinimumCancellationNotice = null;
this.TestingPeriod = false;
this.TestingPeriodEndingDate = null;
this.CollectiveLaborAgreementNotes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
PaymentTime:any;
DigitalJobTimeOrg:any;
ObligatoryKnowleadge:any;
WorkPlace:any;
WorkPlaceComments:any;
UnpredictedWorkScedule:any;
DaysAndHours:any;
MinimumTimeNotice:any;
MinimumCancellationNotice:any;
TestingPeriod:any;
TestingPeriodEndingDate:any;
CollectiveLaborAgreementNotes:any;
MainCoverage:any;
OtherCoverage:any;
CollectiveLaborAgreement:any;
AcceptanceOfTerms:any;
static setMainCoverage = ($this, value) => {
var oldValue = $this.MainCoverage;
$this.MainCoverage = value;
if (value != null) {
}
}
static setOtherCoverage = ($this, value) => {
var oldValue = $this.OtherCoverage;
$this.OtherCoverage = value;
if (value != null) {
}
}
static setCollectiveLaborAgreement = ($this, value) => {
var oldValue = $this.CollectiveLaborAgreement;
$this.CollectiveLaborAgreement = value;
if (value != null) {
}
}
static setAcceptanceOfTerms = ($this, value) => {
var oldValue = $this.AcceptanceOfTerms;
$this.AcceptanceOfTerms = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}